import type {ImportSaving, ImportState} from '@gaia/types';
import {Backdrop, LinearProgress, Typography} from '@mui/material';
import {useEffect, useState} from 'react';

import classes from './SavingSurface.module.css';

interface SavingSurfaceProps {
    unsaved: number;
    importState: ImportSaving;
    setImportState: SetState<ImportState>;
}

export function SavingSurface({unsaved, importState, setImportState}: SavingSurfaceProps) {
    const [saved, setSaved] = useState(0);

    // Keep track of how many items need to be saved
    useEffect(() => {
        // On the first tick importState.unsaved will probably be zero, so don't start incrementing
        // the number of unsaved items until it is 1 less than the total
        if (!importState.unsaved || unsaved !== importState.unsaved - 1) return;

        setImportState({...importState, unsaved});
        setSaved(importState.toSave - unsaved);
    }, [unsaved, importState, setImportState]);

    return (
        <Backdrop className={classes.backdrop} open={true}>
            <div className={classes.content}>
                <Typography variant='h5'>Saving imported items</Typography>
                <LinearProgress
                    color='primary'
                    variant='determinate'
                    value={(saved / importState.toSave) * 100}
                    className={classes.progress}
                />
                <Typography variant='subtitle1'>
                    {saved} of {importState.toSave}
                </Typography>
            </div>
        </Backdrop>
    );
}
